import { FlatFeePricing, FlatFeeTieredPrice, StationeryPricing, TieredPrice } from '../types';

const calculateFixedPrice = (pricing: FlatFeePricing) => {
  return pricing.priceInMinorUnits;
};

const sortQuantities = (tierQuantities: number[]): number[] => {
  // Slice array to clone in case Price Config comes in on a readonly template
  return tierQuantities.sort((tierA, tierB) => {
    return tierB - tierA;
  });
};

const getLowestTier = (tierQuantities: number[], quantity: number): number | undefined => {
  return sortQuantities(tierQuantities).find(t => quantity >= t);
};

const calculateTieredPrice = (pricing: TieredPrice, quantity: number): number => {
  const lowestTier = getLowestTier(
    pricing.priceTiers.map(t => t.minQuantity),
    quantity
  );
  const tierForQuantity = pricing.priceTiers.find(t => t.minQuantity === lowestTier);

  if (!tierForQuantity) {
    throw new Error(`No tier found for quantity ${quantity}`);
  }

  return tierForQuantity.unitPriceInMinorUnits * quantity;
};

const calculateFlatFeeTieredPrice = (pricing: FlatFeeTieredPrice, quantity: number): number => {
  const lowestTier = getLowestTier(
    pricing.priceTiers.map(t => t.minQuantity),
    quantity
  );
  const tierForQuantity = pricing.priceTiers.find(t => t.minQuantity === lowestTier);

  if (!tierForQuantity) {
    throw new Error(`No tier found for quantity ${quantity}`);
  }

  return tierForQuantity.totalPriceInMinorUnits;
};

/**
 * Calculate the total price of a StationeryPricing object.
 * @param pricing Object to evaluate
 * @param quantity Quantity to calculate price for
 * @returns Extended price. priceEach * quantity for Tiered, price for FlatFee
 */
export const calculateStationeryPricing = (pricing: StationeryPricing, quantity: number): number => {
  const type = pricing.__typename;

  switch (type) {
    case 'StationeryFlatFeePricing':
      return calculateFixedPrice({ ...pricing, __typename: 'StationeryFlatFeePricing' });
      break;
    case 'StationeryTieredPricing':
      return calculateTieredPrice({ ...pricing, __typename: 'StationeryTieredPricing' }, quantity);
      break;
    case 'StationeryTieredFlatFeePricing':
      return calculateFlatFeeTieredPrice({ ...pricing, __typename: 'StationeryTieredFlatFeePricing' }, quantity);
      break;
  }

  throw new Error('Invalid price definition.');
};
